import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ARTWORKS } from "../data/artworks";

export function useArtworks() {
  const [items, setItems] = useState(ARTWORKS);
  useEffect(() => {
    let alive = true;
    api.get("/artworks")
      .then((r) => { if (alive && Array.isArray(r.data) && r.data.length) setItems(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return items;
}
